'use client';
import { Fragment as _Fragment, jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, isValidElement, cloneElement } from 'react';
import { extractProps } from '@radix-ui/themes/helpers';
import { Button } from '../button/index.js';
import { IconButton } from '../icon-button/index.js';
import { Tooltip } from '../tooltip/index.js';
import { Flex } from '../layout/index.js';
import { useSideNavigation } from './side-navigation.store.js';
import { sideNavigationItemPropDefs } from './side-navigation.props.js';
const SideNavigationItem = forwardRef((props, forwardedRef) => {
    const { className, children, icon, active, ...otherProps } = extractProps(props, sideNavigationItemPropDefs);
    const { expanded } = useSideNavigation();
    const color = active ? 'accent' : 'neutral';
    if (expanded) {
        const { asChild } = otherProps;
        if (asChild && isValidElement(children)) {
            return (_jsx(Flex, { align: "center", width: '100%', justify: 'start', asChild: true, className: "rt-SideNavigationItem", children: _jsx(Button, { className: className, ref: forwardedRef, color: color, "data-state": active ? 'open' : '', ...otherProps, children: cloneElement(children, {
                        children: (_jsxs(_Fragment, { children: [icon, children.props.children] })),
                        color,
                    }) }) }));
        }
        return (_jsx(Flex, { align: "center", width: '100%', justify: 'start', asChild: true, className: "rt-SideNavigationItem", children: _jsxs(Button, { className: className, ref: forwardedRef, color: color, "data-state": active ? 'open' : '', ...otherProps, children: [icon, children] }) }));
    }
    if (icon) {
        const { asChild, ...otherIconProps } = otherProps;
        if (asChild && isValidElement(children)) {
            return (_jsx(Tooltip, { content: children.props.children, side: "right", className: "rt-SideNavigationItem", children: _jsx(IconButton, { ref: forwardedRef, className: className, color: color, "data-state": active ? 'open' : '', radius: "full", ...otherProps, children: cloneElement(children, { children: icon }) }) }));
        }
        return (_jsx(Tooltip, { content: children, side: "right", className: "rt-SideNavigationItem", children: _jsx(IconButton, { ref: forwardedRef, className: className, color: color, "data-state": active ? 'open' : '', radius: "full", ...otherIconProps, children: icon }) }));
    }
    return null;
});
SideNavigationItem.displayName = 'SideNavigation.Item';
export { SideNavigationItem };
//# sourceMappingURL=side-navigation-item.js.map